const ERC20ABI = [
  "function allowance(address owner, address spender) view returns (uint256)",
  "function approve(address spender, uint256 amount) returns (bool)",
  "function decimals() view returns (uint8)", 
  "function name() view returns (string)",    
  "function symbol() view returns (string)",
  "function balanceOf(address owner) view returns (uint256)",
];

export default ERC20ABI;
